function asIdList(value: unknown): unknown[] {
  if (!Array.isArray(value)) return [];
  return value.filter((item) => item != null && item !== "");
}

function sameIds(left: unknown, right: unknown): boolean {
  const a = asIdList(left).map(String).sort();
  const b = asIdList(right).map(String).sort();
  return a.length === b.length && a.every((item, index) => item === b[index]);
}

function readList(values: Record<string, unknown>, key: string, computedKey: string): unknown[] {
  const direct = values[key];
  if (Array.isArray(direct)) return direct;
  const computed = values[computedKey];
  return Array.isArray(computed) ? computed : [];
}

export function marketGroupMarketIds(values: Record<string, unknown>): unknown[] {
  return readList(values, "marketIds", "computedMarketIds");
}

export function marketGroupTypes(values: Record<string, unknown>): unknown[] {
  return readList(values, "types", "computedTypes");
}

export function marketGroupTags(values: Record<string, unknown>): unknown[] {
  return readList(values, "tags", "computedTags");
}

export function buildMarketGroupCollectionsPatch(
  values: Record<string, unknown>,
  baseline: Record<string, unknown>,
): Record<string, unknown> | null {
  const patch: Record<string, unknown> = {};
  if (!sameIds(marketGroupMarketIds(values), marketGroupMarketIds(baseline))) {
    patch.marketIds = marketGroupMarketIds(values);
  }
  if (!sameIds(marketGroupTypes(values), marketGroupTypes(baseline))) {
    patch.types = marketGroupTypes(values);
  }
  if (!sameIds(marketGroupTags(values), marketGroupTags(baseline))) {
    patch.tags = marketGroupTags(values);
  }
  return Object.keys(patch).length ? patch : null;
}

export function syncMarketGroupCollectionsBaseline(
  values: Record<string, unknown>,
  baseline: Record<string, unknown>,
) {
  baseline.marketIds = [...marketGroupMarketIds(values)];
  baseline.types = [...marketGroupTypes(values)];
  baseline.tags = [...marketGroupTags(values)];
}
